<!--
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-15 17:48:52
 * @LastEditors: Luz Liu luz.liu@zoom.us
 * @LastEditTime: 2022-07-28 16:15:03
 * @FilePath: \async-component-ui\packages\components\unitConvert\unitConvert.vue
 * @Description: ~
-->
<template>
  <div class="as-unit-convert">
    <div
      class="as-unit-convert-unit-wrapper"
      v-for="index in [0, 1, 2, 3]"
      :key="index"
    >
      <div
        class="input-adaptive"
        v-if="minUnitIndex >= index && maxUnitIndex <= index"
      >
        <span>{{ valueList[index] }}</span>
        <input
          type="number"
          v-model.number="valueList[index]"
          @change="updateSum"
          :style="{ borderBottomColor: borderColor }"
        />
      </div>
      <span v-if="minUnitIndex >= index && maxUnitIndex <= index">
        {{ label[typeIndex][index] }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AsUnitConvert',
  props: {
    type: {
      type: String,
      default: 'time',
    },
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
    minUnit: {
      type: String,
      default: 'ms',
    },
    maxUnit: {
      type: String,
      default: 'd',
    },
    borderColor: {
      type: String,
      default: '#0e71eb',
    },
  },
  created() {
    this.updateValue()
  },
  data() {
    return {
      sum: null,
      valueList: [null, null, null, null],
      label: [
        ['Day', 'Hour', 'Min', 'Sec'],
        ['GB', 'MB', 'KB', 'B'],
      ],
      unitList: [
        ['d', 'h', 'm', 's', 'ms'],
        ['g', 'm', 'k', 'b'],
      ],
      typeList: ['time', 'size'],
    }
  },
  computed: {
    typeIndex() {
      return this.typeList.indexOf(this.type)
    },
    minUnitIndex() {
      const index = this.unitList[this.typeList.indexOf(this.type)].indexOf(
        this.minUnit
      )
      return index === -1 ? 0 : index
    },
    maxUnitIndex() {
      const index = this.unitList[this.typeList.indexOf(this.type)].indexOf(
        this.maxUnit
      )
      return index === -1 ? 0 : index
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v, ov) {
        if (v !== ov) {
          this.updateValue()
        }
      },
    },
  },
  methods: {
    updateValue() {
      if (this.value < 0 || !Number.isSafeInteger(this.value)) {
        this.sum = 0
      } else {
        if (this.typeIndex === 0) {
          this.sum = this.formatToMilliSecond(this.value)
        } else if (this.typeIndex === 1) {
          this.sum = this.formatToBytes(this.value)
        }
      }
      this.updateEvery()
    },
    updateSum() {
      if (this.typeIndex === 0) {
        this.updateTime()
      } else if (this.typeIndex === 1) {
        this.updateSize()
      }
      this.updateEvery()
    },
    updateTime() {
      const millisecond = this.getMillisecond()
      const time = this.getTime()
      if (!Number.isSafeInteger(time) || time > this.max) {
        this.sum = this.max
        this.$message({
          duration: 3000,
          message: `Input exceeds maximum ${this.max}, reset to maximum allowed`,
          type: 'warning',
        })
      } else {
        this.sum = millisecond
      }
      this.$emit('input', time)
    },
    updateSize() {
      const bytes = this.getBytes()
      const size = this.getSize()
      if (!Number.isSafeInteger(size) || size > this.max) {
        this.sum = this.max
        this.$message({
          duration: 3000,
          message: `Input exceeds maximum ${this.max}, reset to maximum allowed`,
          type: 'warning',
        })
      } else {
        this.sum = bytes
      }
      this.$emit('input', size)
    },
    updateEvery() {
      if (this.typeIndex === 0) {
        this.valueList[0] = this.getDay(this.sum)
        this.valueList[1] = this.getHour(this.sum)
        this.valueList[2] = this.getMinute(this.sum)
        this.valueList[3] = this.getSecond(this.sum)
      } else if (this.typeIndex === 1) {
        this.valueList[0] = this.getGB(this.sum)
        this.valueList[1] = this.getMB(this.sum)
        this.valueList[2] = this.getKB(this.sum)
        this.valueList[3] = this.getByte(this.sum)
      }
    },
    getDay(millisecond) {
      if (this.maxUnitIndex === 0) {
        return Math.floor(millisecond / 86400000)
      }
      return 0
    },
    getHour(millisecond) {
      if (this.maxUnitIndex === 0) {
        return Math.floor(millisecond / 3600000) - this.getDay(millisecond) * 24
      } else if (this.maxUnitIndex === 1) {
        return Math.floor(millisecond / 3600000)
      }
      return 0
    },
    getMinute(millisecond) {
      if (this.maxUnitIndex === 0) {
        return (
          Math.floor(millisecond / 60000) -
          this.getHour(millisecond) * 60 -
          this.getDay(millisecond) * 1440
        )
      } else if (this.maxUnitIndex === 1) {
        return Math.floor(millisecond / 60000) - this.getHour(millisecond) * 60
      } else if (this.maxUnitIndex === 2) {
        return Math.floor(millisecond / 60000)
      }
      return 0
    },
    getSecond(millisecond) {
      if (this.maxUnitIndex === 0) {
        return (
          Math.floor(millisecond / 1000) -
          this.getMinute(millisecond) * 60 -
          this.getHour(millisecond) * 3600 -
          this.getDay(millisecond) * 86400
        )
      } else if (this.maxUnitIndex === 1) {
        return (
          Math.floor(millisecond / 1000) -
          this.getMinute(millisecond) * 60 -
          this.getHour(millisecond) * 3600
        )
      } else if (this.maxUnitIndex === 2) {
        return Math.floor(millisecond / 1000) - this.getMinute(millisecond) * 60
      } else if (this.maxUnitIndex >= 3) {
        return Math.floor(millisecond / 1000)
      }
      return 0
    },
    getMillisecond() {
      return (
        this.valueList[0] * 86400000 +
        this.valueList[1] * 3600000 +
        this.valueList[2] * 60000 +
        this.valueList[3] * 1000
      )
    },
    getTime() {
      switch (this.minUnitIndex) {
        case 4:
          return (
            this.valueList[0] * 86400000 +
            this.valueList[1] * 3600000 +
            this.valueList[2] * 60000 +
            this.valueList[3] * 1000
          )
        case 3:
          return (
            this.valueList[0] * 86400 +
            this.valueList[1] * 3600 +
            this.valueList[2] * 60 +
            this.valueList[3]
          )
        case 2:
          return (
            this.valueList[0] * 1440 +
            this.valueList[1] * 60 +
            this.valueList[2]
          )
        case 1:
          return this.valueList[0] * 24 + this.valueList[1]
        case 0:
          return this.valueList[0]
        default:
          break
      }
    },
    formatToMilliSecond(val) {
      switch (this.minUnitIndex) {
        case 4:
          return val
        case 3:
          return val * 1000
        case 2:
          return val * 60000
        case 1:
          return val * 3600000
        case 0:
          return val * 86400000
        default:
          break
      }
    },
    getGB(Bytes) {
      if (this.maxUnitIndex === 0) {
        return Math.floor(Bytes / 1073741824)
      }
      return 0
    },
    getMB(Bytes) {
      if (this.maxUnitIndex === 0) {
        return Math.floor(Bytes / 1048576) - this.getGB(Bytes) * 1024
      } else if (this.maxUnitIndex === 1) {
        return Math.floor(Bytes / 1048576)
      }
      return 0
    },
    getKB(Bytes) {
      if (this.maxUnitIndex === 0) {
        return (
          Math.floor(Bytes / 1024) -
          this.getMB(Bytes) * 1024 -
          this.getGB(Bytes) * 1048576
        )
      } else if (this.maxUnitIndex === 1) {
        return Math.floor(Bytes / 1024) - this.getMB(Bytes) * 1024
      } else if (this.maxUnitIndex === 2) {
        return Math.floor(Bytes / 1024)
      }
      return 0
    },
    getByte(Bytes) {
      if (this.maxUnitIndex === 3) {
        return Bytes
      }
      return Math.floor(Bytes % 1024)
    },
    getBytes() {
      return (
        this.valueList[0] * 1073741824 +
        this.valueList[1] * 1048576 +
        this.valueList[2] * 1024 +
        this.valueList[3]
      )
    },
    getSize() {
      switch (this.minUnitIndex) {
        case 3:
          return (
            this.valueList[0] * 1073741824 +
            this.valueList[1] * 1048576 +
            this.valueList[2] * 1024 +
            this.valueList[3]
          )
        case 2:
          return (
            this.valueList[0] * 1048576 +
            this.valueList[1] * 1024 +
            this.valueList[2]
          )
        case 1:
          return this.valueList[0] * 1024 + this.valueList[1]
        case 0:
          return this.valueList[0]
        default:
          break
      }
    },
    formatToBytes(val) {
      switch (this.minUnitIndex) {
        case 3:
          return val
        case 2:
          return val * 1024
        case 1:
          return val * 1048576
        case 0:
          return val * 1073741824
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.as-unit-convert {
  display: inline-block;
  width: max-content;
  border: none;
  box-sizing: border-box;
  padding: 2px;

  .as-unit-convert-unit-wrapper {
    display: inline-block;
    span {
      display: inline-block;
      padding: 0 2px;
      height: 100%;
    }
    .input-adaptive {
      position: relative;
      display: inline-block;
      padding: 0;
      margin: 0;

      input {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
        outline: 0;
        text-align: center;
        vertical-align: center;
        border-bottom: 2px solid transparent;
      }

      input[type='number']::-webkit-inner-spin-button,
      input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type='number'] {
        -moz-appearance: textfield;
      }
    }
  }
}
</style>
